export default __webpack_public_path__ + "static/media/stvincentdepaul.99375314.jpg";